export default __webpack_public_path__ + "static/media/cartemaps.a66d1430.png";